export default __webpack_public_path__ + "static/carrier-background-220a278ce2616df65b6d8a6d2fb0fd1b.jpg";